<template>
    <div class="inviteregis-container">
        <div class="form-container">
            <van-button class="register-btn" @click="handleDownload">点击下载APP</van-button>
        </div>
    </div>
</template>
<script>

export default {
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        handleDownload () {
            this.$router.push('/download')
        }
    }
}
</script>

<style lang="less" scoped>
.button-wrapper {
    display: flex;
    padding: 0 15px;
    justify-content: space-between;
    .van-button {
        height: 40px;
        font-size: 22px;
        letter-spacing: 1px;
        padding: 0;
        width: 166px;
        &.face-invite {
            color: #F93B36;
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(254, 108, 96, 1);
            //border-image: linear-gradient(180deg, rgba(254, 108, 96, 1), rgba(247, 41, 35, 1)) 1 1;
        }
        &.instance-invite {
            background: linear-gradient(180deg, #FF6864 0%, #F82923 100%);
            color: white;
            border-color: #FF6864;
        }
    }
}
.inviteregis-container {
    width: 375px;
    background: url(../assets/success.png)top left/100% 100% no-repeat;
    background-size: 100%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    position: absolute;
    height: 100%;
    min-height: 100%;
    .form-container {
        padding: 0 15px;
        margin-top: 165%;
        .register-btn {
            width: 100%;
            background: linear-gradient(180deg, #FF6763 0%, #F82A24 100%);
            border-radius: 8px;
            border: none;
            color: #fff;
            font-size: 16px;
        }
    }
}
</style>
